// todo getlist页面
import { request } from '@/common/utils/request'
import { getBDCountry, getBDTimezone } from '@/common/utils/i18n'
export const getCommonParams = function () {
  return {
    country: getBDCountry(),
    timezone: getBDTimezone(),
  }
}
export const handleParams = function (pendingParams = {}, hasType) {
  const pendedParams = {
    lat: pendingParams.lat + '',
    lng: pendingParams.lng + '',
    potential: pendingParams.potential.map(num => num.toString()),
    status: pendingParams.status.map(num => num.toString()),
    arrTag: pendingParams.arrTag.map(num => num.toString()),
    priority: pendingParams.priority.map(num => num.toString()),
    storeFrontStatus: parseInt(pendingParams.storeFrontStatus.join('')),
    openCheck: pendingParams.openCheck.map(num => num.toString()),
    source: pendingParams.source.map(num => num.toString()),
    bdOpenCheckStatus: pendingParams.bdOpenCheckStatus.map(num => num.toString()),
  }

  if (hasType) {
    pendedParams.type = pendingParams.type.map(num => num.toString())
  }
  const commonparams = getCommonParams()
  const allParams = Object.assign({}, pendingParams, commonparams, pendedParams)
  return allParams
}

export async function getList(params = {}) {
  const allParams = handleParams(params, true)
  return request
    .post({
      url: 'feidian.bdapp.bizopp.getList', // 'https://mock.xiaojukeji.com/mock/12854/bizopp/bdapp/getList',//
      data: allParams,
    })
    .then(res => {
      return res.data
    })
}

export function getAreaList(params) {
  const allParams = handleParams(params, false)
  return request
    .post({
      url: 'feidian.bdapp.area.getList',
      data: allParams,
    })
    .then(res => {
      return res.data
    })
}
